import { render, staticRenderFns } from "./settingsRightsToInvoiceFunnel.vue?vue&type=template&id=b9005d96&"
import script from "./settingsRightsToInvoiceFunnel.vue?vue&type=script&lang=js&"
export * from "./settingsRightsToInvoiceFunnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports